<template>
    <div class="j-colour-tag" @click="$emit('click')">
        <div class="j-colour-tag-content" :style="select ? `background-color: rgba(${HexToRgb(color)}, .25);border-color: ${color};` : `background-color: rgba(${HexToRgb(color)}, .25);`">
            <div class="j-colour-tag-content-desc">
                <i :style="`border-color: ${color}`" />
                <div :title="desc">{{desc}}</div>
            </div>
            <div :title="value" class="j-colour-tag-content-count">
                {{value}}
            </div>
        </div>
    </div>
</template>

<script>
    import { HexToRgb } from '../JTool/color/color'

    export default {
        name: 'JColourTag',
        props: {
            select: { // 是否选中
                type: Boolean,
                default: false
            },
            value: { // 数字统计值
                type: [String, Number]
            },
            desc: { // 描述
                type: String,
                default: ''
            },
            color: { // 颜色 16进制值
                type: String,
                default: ''
            }
        },
        methods: {
            HexToRgb
        }
    }
</script>

<style lang="scss">
    .j-colour-tag {
        display: inline-block;
        width: 132px;
        height: 64px;
        margin-right: 12px;
        margin-bottom: 6px;
        box-sizing: border-box;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        .j-colour-tag-content {
            height: 100%;
            background-color: rgba(171, 203, 255, 0.25);
            border-bottom: 3px solid;
            padding: 10px 14px;
            border-color: transparent;
            box-sizing: border-box;

            .j-colour-tag-content-desc {
                display: flex;
                align-items: center;
                font-size: 12px;
                font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
                font-weight: normal;
                color: #666;
                line-height: 18px;
                > i {
                    display: inline-block;
                    height: 8px;
                    width: 8px;
                    border: 2px solid #409EFF;
                    background-color: #fff;
                    box-sizing: border-box;
                    border-radius: 50%;
                    margin-right: 4px;
                }
                > div {
                    flex: 1;
                    min-width: 30px;
                    overflow:hidden; //超出的文本隐藏
                    text-overflow:ellipsis; //溢出用省略号显示
                    white-space:nowrap; //溢出不换行
                }
            }
            .j-colour-tag-content-count {
                padding-left: 12px;
                font-size: 18px;
                font-family: TeXGyreAdventor-Bold, TeXGyreAdventor;
                font-weight: bold;
                color: #666;
                line-height: 18px;
                margin-top: 4px;
                overflow:hidden; //超出的文本隐藏
                text-overflow:ellipsis; //溢出用省略号显示
                white-space:nowrap; //溢出不换行
            }
        }
    }
</style>
